import { useEffect } from 'react'
import { tracking } from 'lib/segment/tracking'
import { useSelector } from 'store/hooks/useSelector'

export function useIdentifyUser() {
  const profile = useSelector((state: any) => state.waitingRoomReducer.providerProfile)

  useEffect(() => {
    if (profile.ProviderId) {
      tracking.identifyUser(profile.ProviderId, {
        email: profile.Email,
      })
    } else {
      tracking.reset()
    }
  }, [profile])
}
